<div class="d-flex h-100 align-items-center justify-content-start" *ngIf="currentUserRanking">
    <div [hidden]="hasCurrentMetrics || moduleManager.moduleSettings.hideDatePicker" class="divider ml-2 mr-3"></div>
    <p #rankElement [ngClass]="{ 'current-metric-space': hasCurrentMetrics || moduleManager.moduleSettings.hideDatePicker }" class="my-rank mb-0 ellipsis mr-2" [tooltip]="isTextTruncated() ? popRank : ''" containerClass="cxone-tooltip-rank" container="body" placement="bottom">
        <span cvLocalizedText langSection="My_Ranking" langKey="My_Rank">My Rank</span>: <span class="rank">{{ currentUserRanking }}</span>
    </p>
    <ng-template #popRank>
        <p class="my-rank mb-0">
            <span cvLocalizedText langSection="My_Ranking" langKey="My_Rank">My Rank</span>: <span class="rank">{{ currentUserRanking }}</span>
        </p>
    </ng-template>
</div>
